import React from 'react';
import CampaignBanner, {
  CampaignBannerFields,
} from '../../../../../components/presentational/CampaignBanner';

export interface CampaignBannerBlockData extends CampaignBannerFields {
  type: 'campaign_banner_block';
}

export interface CampaignBannerBlockProps {
  block: CampaignBannerBlockData;
}

/**
 * Standalone Campaign Banner collection block. Thin wrapper that maps the CMS
 * block data onto the shared CampaignBanner presentational component.
 */
const CampaignBannerBlock = ({ block }: CampaignBannerBlockProps) => (
  <CampaignBanner
    kicker={block.kicker}
    title={block.title}
    subtitle={block.subtitle}
    ctaLabel={block.ctaLabel}
    ctaUrl={block.ctaUrl}
    backgroundColor={block.backgroundColor}
    placement={'collection'}
  />
);

export default CampaignBannerBlock;
